namespace Nobox {
    export interface AddAgentToConversationCLass {
        RoomId?: number;
        UserId?: number;
        isHanded?: number;
        RoomAgent?: ChatroomagentsRow;
        Msg?: ChatmessagesRow;
    }
}
